import { createContext, useContext, useState, useEffect } from 'react';
import { fetchConfig } from '../util';
const ConfigContext = createContext(null);
export const ConfigProvider = ConfigContext.Provider;
export const setupConfig = () => {
    const [{ config, error }, setConfig] = useState({ config: null });
    useEffect(() => {
        fetchConfig()
            .then((config) => setConfig({ config }))
            .catch((error) => {
            console.warn('error fetching config:', error.toString());
            setConfig({ error, config: null });
        });
    }, []);
    return { config, error, showSpinner: !config && !error };
};
export const useConfig = () => {
    const ctx = useContext(ConfigContext);
    if (!ctx) {
        throw new Error('ConfigContext not set');
    }
    return ctx;
};
//# sourceMappingURL=config.js.map